import { useNuxtApp } from "#app"; // 导入 `useNuxtApp`
import {
  getPrefixUrl,
  checkMallFetchUrl,
  getMockUrl,
  getCookieToken,
} from "@/utils/globalData"; // 导入 `useNuxtApp`

import { useMainStore } from "../composables/store";



/**
 * 获取token
 
 * @param params
 * @returns {*}
 */
export function getOssToken(body, $fetch, headers) {
  
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/merchant/basic/aliyun/getToken?isShop=1",
      {
     
      }
    );
  }
  return useNuxtApp().$customFetch(
    "/merchant/basic/aliyun/getToken?isShop=1",
    
  );
}
export function makeUnSetupFetch($fetch, headers, url, options) {
  let hostSite =
    headers?.referer &&
    headers.referer
      .replace("http://", "")
      .replace("https://", "")
      .split("/")[0];

  if (headers?.host) {
    hostSite = headers.host;
  }

  if (headers?.["x-custom-header1"]) {
    hostSite = headers["x-custom-header1"];
  }

  if (process.client) {
    hostSite = window.location.host;
  }

  if (getMockUrl()) {
    hostSite = getMockUrl();
  }
  const tokenKey = `openaccessjwt_${hostSite}`;
  const defaultHeaders = {
    ...(options.headers || {}),
  };
  const store = useMainStore();
  // 如果有 mockJwtMap 或 store 中的 token，将其添加到请求头
  if (mockJwtMap[getPrefixUrl()]) {
    defaultHeaders["openaccessjwt"] = mockJwtMap[getPrefixUrl()];
  }


  if (store && store.$state.tokenKeyMap[tokenKey]) {
    defaultHeaders["openaccessjwt"] = store.$state.tokenKeyMap[tokenKey];
  }

  if (store && store.$state.shopIdKeyMap[tokenKey]) {
    defaultHeaders["shopId"] = store.$state.shopIdKeyMap[tokenKey];
  }

  let setOptions = {
    ...options,
    baseURL: getPrefixUrl(),
    headers: { ...(options.headers || {}), ...defaultHeaders },
  };

  if (process.client && (!options.body || !options.body.unhaveToken)) {
    let isMallUrl = checkMallFetchUrl(url);
    if (isMallUrl) {
      setOptions.headers.authorization = getMallAppToken();
    } else {
      const token = getToken();
      if (typeof setOptions.headers != "undefined") {
        if (typeof token === "string") {
          setOptions.headers.authorization = token;
        } else {
          setOptions.headers.authorization = "";
        }
      }
    }
  } else if (process.server && (!options.body || !options.body.unhaveToken)) {
    // 服务端时从 cookie 获取 sj_mall_admin_token
    const cookieToken = getCookieToken(headers);
    if (cookieToken) {
      setOptions.headers.authorization = cookieToken;
    }
  }

  return $fetch(url, setOptions);
}

/**
 * 获取轮播图信息
 
 * @param params
 * @returns {*}
 */
export function getBanner(params) {
  return useNuxtApp().$customFetch("/api/indexpic/list", {
    method: "GET",
    params,
  });
}

/**
 * 获取栏目
 
 * @param params
 * @returns {*}
 */
export function getColumn(params) {
  return useNuxtApp().$customFetch("/api/column/list", {
    method: "GET",
    params,
  });
}

/**
 * 获取某个资讯详情
 
 * @param params
 * @returns {*}
 */
export function getContentInfo(params) {
  return useNuxtApp().$customFetch("/api/content/info/" + params.id, {
    params,
  });
}

/**
 * 获取文章列表
 
 * @param params
 * @returns {*}
 */
export function getContentList(params) {
  return useNuxtApp().$customFetch("/api/content/list", {
    params: { ...params, limit: params.pageSize },
  });
}

/**
 * 分页获取友情链接
 
 * @param params
 * @returns {*}
 */
export function getConvenientList(params) {
  return useNuxtApp().$customFetch("/api/convenient/list", { params });
}

/**
 * 查询考生是否被录取
 
 * @param params
 * @returns {*}
 */
export function matriculatestat(params) {
  return useNuxtApp().$customFetch("/api/matriculate/stu/matriculatestate", {
    method: "POST",
    params,
  });
}

/**
 * 查询活动页
 
 * @param params
 * @returns {*}
 */
export function getActiveDetail(body, $fetch, headers) {
  
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/frontServer/active-page/list?isShop=1",
      {
        method: "POST",
        body: { ...body, unhaveToken: 1 },
      }
    );
  }
  return useNuxtApp().$customFetch(
    "/frontServer/active-page/list?isShop=1",
    { method: "POST", body: { ...body, unhaveToken: 1 } }
  );
}
/**
 * 查询参数
 
 * @param params
 * @returns {*}
 */
export function getArgument(params) {
  return useNuxtApp().$customFetch(
    "/platform/portal/sysArgument/queryArgument",
    {
      method: "POST",
      body: { params },
    }
  );
}

/**
 * 查询配置
 
 * @param params
 * @returns {*}
 */
export function getWebsiteHomePageInfo(params) {
 
  return useNuxtApp().$customFetch(
    "/frontServer/display-config/match-url?currentServer=" +
      params.currentServer,
    {
      method: "POST",
      body: { url: params.currentServer }
     
    }
  );
}

/**
 * 查询店铺配置
 
 * @param params
 * @returns {*}
 */
export function getWebStorePageInfo(params) {
  return new Promise((resolve) => {
    resolve({
      success: true,
      status: "SUCCESS",
      msg: "成功",
      data: {
        id: "919991359526363136",
        dealerInfoId: null,
        dealerUserId: null,
        title: "星际货运(中转)",
        logoUrl:
          "http://minio-tmall-test-intl.omszt.com/supplychain/rechargeProofFile/17396076409091726903639681%5E%E5%A4%A9%5E%E9%A9%AC%5E%E8%BF%90%5E%E9%80%9A%20%281%29%20%281%29%20%282%29%20%281%29.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=minioAdmin%2F20250911%2Fdefault%2Fs3%2Faws4_request&X-Amz-Date=20250911T023227Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Signature=0ef63a016829013db6a482344e2252dc4566afcd8591f5107373b4b864fb6e3e",
        shopState: null,
        liveState: null,
        banLiveStartTime: null,
        banLiveEndTime: null,
        banLiveDuration: null,
        banLiveReason: null,
        deleted: null,
        followSum: 0,
        score: null,
        shopLiveState: 0,
        isFollow: 0,
        dealerShopLivePlanId: null,
        dealerItemSpuRespDTOS: null,
        shopIntroduction: null,
        shopBackUrl: null,
        shopScore: null,
        offiaccountFollowUrl:
          '{"customerService":"https://mp.weixin.qq.com/s?__biz=MzkyNjM5OTQ5Mw==&mid=2247483669&idx=1&sn=88e5ab68f6aabd130d9d265385f2c7a6&chksm=c236ac7ff5412569849877231d0a871e5c415b1be4b9070a5b49b496a100d93cf511504ec134#rd","welfareGroup":"","help":"https://mp.weixin.qq.com/s?__biz=MzkyNjM5OTQ5Mw==&mid=2247483670&idx=1&sn=7f20443769e7d1bb9c2128839771d9d2&chksm=c236ac7cf541256a32eab31a23cac9836484ef4974ddf73d83572c6967dde71219a829ee1358#rd","follow":"https://mp.weixin.qq.com/s?__biz=MzkyNjM5OTQ5Mw==&mid=2247483679&idx=1&sn=d713449910d1b75f8c5e9c4cd34464e9&chksm=c236ac75f541256363040c0f12309708951b9a419707c61f341ef8e10b0bb9e7ef63a1592a96#rd","newMemberGuide":"https://mp.weixin.qq.com/s?__biz=MzkyNjM5OTQ5Mw==&mid=2247483674&idx=1&sn=60429dece2c8cdcb95f552713c7c4208&chksm=c236ac70f54125662f651c1f09dee42c5234f44f93872b99814fefd51fc79df2ecfc1fa9787f#rd","prohibitedArticle":"https://mp.weixin.qq.com/s?__biz=MzkyNjM5OTQ5Mw==&mid=2247483668&idx=1&sn=b268f0ffc847af8ccd530662b842899b&chksm=c236ac7ef54125681bb48923ac711edb1bcb764e622c89b21d4c7021308800f1c84e0279fc14#rd","otherJson":"{\\n  \\"defaultCountry\\": \\"中國臺灣\\",\\n  \\"excutePhoneArea\\": [\\"86\\"],\\n  \\"defaultLocale\\": \\"zh-Hans\\",\\n  \\"mallApiUrl\\": \\"http://api-test.jyshop.omszt.com:8081/mall\\",\\n  \\"clientConfigUrl\\": \\"https://wcs0015.dzpaas.com:446/newwebchat/talking-box.html?pid=WCL-0065&sid=0000\\",\\n  \\"clientConfigs1\\": [\\n    {\\n      \\"type\\": \\"wechat\\",\\n      \\"icon\\": \\"https://sztjyshop-prod.oss-cn-guangzhou.aliyuncs.com/imgs/2023/01-16/upload_pic_1673856196040_%E5%BE%AE%E4%BF%A1.png\\",\\n      \\"url\\": \\"https://work.weixin.qq.com/kfid/kfcc8d8b84bffb3d116\\"\\n    },\\n    {\\n      \\"type\\": \\"line\\",\\n      \\"icon\\": \\"https://sztjyshop-prod.oss-cn-guangzhou.aliyuncs.com/imgs/2022/12-22/upload_pic_1671678199360_line%20(1).png\\",\\n      \\"url\\": \\"https://lin.ee/2BZVyxV\\"\\n    },\\n    {\\n      \\"type\\": \\"onlineService\\",\\n      \\"icon\\": \\"https://front-site.oss-cn-hongkong.aliyuncs.com/imgs/2024/09-26/footer-logo1.png\\",\\n      \\"url\\": \\"https://wcs0015.dzpaas.com:446/newwebchat/talking-box.html?pid=WCL-0065&sid=\\"\\n    }\\n  ],\\n  \\"aiUrl\\": \\"http://ai-test.m-shop-test.omszt.com:7888\\",\\n  \\"bindBuyMallUrl\\": \\"http://xjhy.mall-test.erp-buy-site.buyagent.omszt.com:8081\\",\\n  \\"hideProxyAliWithdrawal\\": \\"1\\",\\n  \\"aiHumanClientUrl\\": \\"https://wcs0015.dzpaas.com:446/newwebchat/talking-box.html?pid=WCL-0063&sid=\\",\\n  \\"dzClientChatUrl\\": \\"https://wcs0015.dzpaas.com:446/newwebchat/talking-box.html?pid=WCL-0063&sid=\\",\\n  \\"isHiddenCurrencySymbol\\": true,\\n  \\"appInfoPage\\": {\\n    \\"appLogo\\": \\"https://front-site.oss-accelerate.aliyuncs.com/imgs/2025/08-25/upload_pic_1756093371009_rainbow%20(2).png\\",\\n    \\"appName\\": \\"Rainbow Mall\\",\\n    \\"appInfoText\\": \\"Shop Everything From China With Guaranteed Service\\",\\n    \\"iosAppDownloadUrl\\": \\"https://apps.apple.com/cn/app/rainbow-mall/id1544424180\\",\\n    \\"androidAppDownloadUrl\\": \\"https://sztjyshop.oss-cn-guangzhou.aliyuncs.com/tmp/rainbowmall.apk\\",\\n    \\"appUrlScheme\\": \\"rainbowlogistics\\",\\n    \\"appBannerList\\": [\\n      {\\n        \\"picture\\": \\"https://front-site.oss-accelerate.aliyuncs.com/imgs/2025/08-25/upload_pic_1756093244089_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250825114031_150.jpg\\"\\n      },\\n      {\\n        \\"picture\\": \\"https://front-site.oss-accelerate.aliyuncs.com/imgs/2025/08-25/upload_pic_1756093317326_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250825114026_149.png\\"\\n      },\\n      {\\n        \\"picture\\": \\"https://front-site.oss-accelerate.aliyuncs.com/imgs/2025/08-25/upload_pic_1756093244089_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250825114031_150.jpg\\"\\n      }\\n    ]\\n  }\\n}\\n","clientDownloadConfig":"[{\\"name\\":\\"最新版\\",\\"url\\":\\"https://nwjs.readthedocs.io/en/latest/For%20Users/Advanced/Use%20Native%20Node%20Modules\\"},{\\"name\\":\\"32位兼容版\\",\\"url\\":\\"https://baidu.com\\"}]"}',
        type: null,
        orgId: null,
        dealerShopLiveStreamerRespDTOList: null,
        ownerCode: null,
        ownerName: null,
        customerId: null,
        customerName: null,
        code: null,
        siteList: null,
        signUserId: null,
        contactName: null,
        contactPhone: null,
        contactTel: null,
        contactAddress: null,
        createTime: null,
        creatorCode: null,
        creatorName: null,
        modifyTime: null,
        modifierCode: null,
        modifierName: null,
        mineOwnerCode: null,
        mineOwnerName: null,
        memberCodeRule: null,
        maxim: "^最^快^、^最^稳^、^最^牛^逼",
        agreement: "<p>1^测^试^店^铺^专^用</p>",
        defaultLanguage: null,
        jyOrderRuleExpression: null,
        defaultCurrencyCode: "CNY",
        createOrderTips: null,
        defaultCurrencyName: null,
        autoAuditOrderFlag: null,
        batchAuditQuota: null,
        submitAllRelatedByInput: null,
        submitAllRelatedByImport: null,
        defaultCurrencySymbol: null,
        scId: "1",
        cancelOrderRule: null,
        openSmsVerify: 1,
        smsPlatform: null,
        partnership: null,
        freeDays: null,
        adventDays: null,
        beOverAutoDestroy: null,
        storageArticleDesc: null,
        noticeStrategy: null,
        showWarehouseWeightFlag: null,
        autoAuditRulesFlag: null,
        autoAuditRulesHandleTime: null,
        itemSum: 0,
      },
    });
  });

  return useNuxtApp().$customFetch("/admin/dealerShop/queryDealerShop", {
    method: "POST",
    body: { shopBackUrl: params.currentServer },
  });
}

/**
 * 查询站点身份
 * @param params
 * @returns {*}
 */
export function querySiteIdentityByShopId(params) {
  return useNuxtApp().$customFetch(
    `/admin/dealerShop/querySiteIdentityByShopId`,
    {
      method: "GET",
      params,
    }
  );
}

/**
 * 查询文章列表
 
 * @param params
 * @returns {*}
 */
export function getActiveListByTopicId($axios, params) {
  return useNuxtApp().$customFetch(
    "/admin/manage/article/queryArticleListByTopicId",
    {
      method: "POST",
      body: { params },
    }
  );
}

// 获取Tabbar配置
export function getTabBarConfigList(params) {
  return useNuxtApp().$customFetch(
    "/frontServer/tabBar/list",
    {
      method: "POST",
      body: params,
    }
  );
}
// 获取文章详情
export function getArticleDetails(params) {
  return useNuxtApp().$customFetch(
    "/platform/admin/manage/article/articleList",
    {
      method: "POST",
      body: params,
    }
  );
}
/**
 * 查询文章列表
 
 * @param params
 * @returns {*}
 */
export function getActiveListFormPlatform(params, $fetch, headers) {
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/platform/admin/manage/article/articleList",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/platform/admin/manage/article/articleList",
      {
        method: "POST",
        body: params,
      }
    );
  }
}

/**
 * 查询tags列表
 
 * @param params
 * @returns {*}
 */
export function getTagsFormPlatform(params) {
  return useNuxtApp().$customFetch(
    "/platform/admin/tagDetail/tagDetailPageList",
    {
      method: "POST",
      body: params,
    }
  );
}

/**
 * 批量查询文章列表
 
 * @param params
 * @returns {*}
 */
export function mutiQueryArticleInCache($fetch, headers, params) {
  return makeUnSetupFetch(
    $fetch,
    headers,
    "/platform/admin/manage/article/mutiQueryArticleInCache",
    {
      method: "POST",
      body: params,
    }
  );
}

/**
 * 查询文章分类
 
 * @param params
 * @returns {*}
 */
export function getArticleCategoryList(params) {
  return useNuxtApp().$customFetch(
    "/platform/admin/manage/articleCategory/articleCategoryList",
    { method: "POST", body: params }
  );
}

export function queryTracking(params) {
  let setHeaders = {
    tracking_query_token: "823638A63866F824F91D64E236E06FCC",
  };
  if (
    window &&
    window.localStorage &&
    window.localStorage.getItem("tracking_query_meta")
  ) {
    setHeaders.tracking_query_meta = window.localStorage.getItem(
      "tracking_query_meta"
    );
  }
  return useNuxtApp().$customFetch("/mall-home/queryTracking", {
    method: "GET",
    params,
    headers: setHeaders,
  });
}

/**
 * 查询商品列表
 
 * @param params
 * @returns {*}
 */
export function getGoodsListFormPlatform($axios, url, params) {
  return useNuxtApp().$customFetch(url, params, {
    method: "POST",
    body: params,
    changeOrigin: true,
    headers: setHeaders,
  });
}

/**
 * 查询1688商品列表
 
 * @param params
 * @returns {*}
 */
export function get1688GoodsList(params, $fetch, headers) {

  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/alibabaGoods/productSearchKeywordQuery",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/alibabaGoods/productSearchKeywordQuery",
      {
        method: "POST",
        body: params,
      }
    );
  }
}

/**
 * 查询独立站商品列表
 
 * @param params
 * @returns {*}
 */
export function getShopGoodsList(params, $fetch, headers) {
  if (!params.dealerShopId) {
    try {
      const dealerShopIdCookie = useCookie("dealerShopId", { path: "/" });
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        params.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (e) {
      // SSR fallback: parse from incoming request headers
      if (headers && headers.cookie && typeof headers.cookie === "string") {
        const match = headers.cookie.match(/(?:^|;\s*)dealerShopId=([^;]+)/);
        if (match && match[1]) {
          try {
            params.dealerShopId = decodeURIComponent(match[1]);
          } catch (_) {}
        }
      }
    }
  }
  if(params.dealerShopId&&params.param){
    params.param.dealerShopId = params.dealerShopId;
  }
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallIndex/querySpuItemList?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallIndex/querySpuItemList?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  }
}



/**
 * 查询独立站商品列表
 
 * @param params
 * @returns {*}
 */
export function getShopGoodsFilterList(params, $fetch, headers) {
  if (!params.dealerShopId) {
    try {
      const dealerShopIdCookie = useCookie("dealerShopId", { path: "/" });
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        params.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (e) {
      // SSR fallback: parse from incoming request headers
      if (headers && headers.cookie && typeof headers.cookie === "string") {
        const match = headers.cookie.match(/(?:^|;\s*)dealerShopId=([^;]+)/);
        if (match && match[1]) {
          try {
            params.dealerShopId = decodeURIComponent(match[1]);
          } catch (_) {}
        }
      }
    }
  }
  if(params.dealerShopId&&params.param){
    params.param.dealerShopId = params.dealerShopId;
  }
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallGoods/filterList?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallGoods/filterList?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  }
}



/**
 * 查询独立站商品列表根据品牌的分类
 
 * @param params
 * @returns {*}
 */
export function searchByBrandAndCategory(params, $fetch, headers) {
  if (!params.dealerShopId) {
    try {
      const dealerShopIdCookie = useCookie("dealerShopId", { path: "/" });
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        params.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (e) {
      // SSR fallback: parse from incoming request headers
      if (headers && headers.cookie && typeof headers.cookie === "string") {
        const match = headers.cookie.match(/(?:^|;\s*)dealerShopId=([^;]+)/);
        if (match && match[1]) {
          try {
            params.dealerShopId = decodeURIComponent(match[1]);
          } catch (_) {}
        }
      }
    }
  }
  if(params.dealerShopId&&params.param){
    params.param.dealerShopId = params.dealerShopId;
  }
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallGoods/searchByBrandAndCategory?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallGoods/searchByBrandAndCategory?isShop=1&uncheck401=1",
      {
        method: "POST",
        body: params,
      }
    );
  }
}
/**
 * 查询独立站商品详情
 * @param params
 * @returns {*}
 */
export function getProductDetail(params, $fetch, headers) {  
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallItemComment/getItemCommentBySpuId?isShop=1",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallItemComment/getItemCommentBySpuId?isShop=1",
      {
        method: "POST",
        body: params,
      }
    );
  }
}
export function getGoodDetail(params, $fetch, headers) {  
  // ensure dealerShopId exists in body.param from cookie on both SSR and client
  const body = { ...(params || {}) };
  const innerParam = { ...(body.param || {}) };

  if (!innerParam.dealerShopId) {
    try {
      const dealerShopIdCookie = useCookie("dealerShopId", { path: "/" });
      if (dealerShopIdCookie && dealerShopIdCookie.value) {
        innerParam.dealerShopId = dealerShopIdCookie.value;
      }
    } catch (e) {
      // SSR fallback: parse from incoming request headers
      if (headers && headers.cookie && typeof headers.cookie === "string") {
        const match = headers.cookie.match(/(?:^|;\s*)dealerShopId=([^;]+)/);
        if (match && match[1]) {
          try {
            innerParam.dealerShopId = decodeURIComponent(match[1]);
          } catch (_) {}
        }
      }
    }
  }

  body.param = innerParam;

  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/mallGoods/itemSpuDetail?isShop=1",
      {
        method: "POST",
        body,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/mallGoods/itemSpuDetail?isShop=1",
      {
        method: "POST",
        body,
      }
    );
  }
}


/**
 * 查询1688店铺商品列表
 
 * @param params
 * @returns {*}
 */
export function get1688SellerGoodsList(params, $fetch, headers) {
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/alibabaGoods/productSearchQuerySellerOfferList",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/alibabaGoods/productSearchQuerySellerOfferList",
      {
        method: "POST",
        body: params,
      }
    );
  }
}

/**
 * 查询1688商品列表从图片
 
 * @param params
 * @returns {*}
 */
export function get1688GoodsListByImg(params, $fetch, headers) {
  if ($fetch) {
    return makeUnSetupFetch(
      $fetch,
      headers,
      "/mall/admin/alibabaGoods/productSearchImageQuery",
      {
        method: "POST",
        body: params,
      }
    );
  } else {
    return useNuxtApp().$customFetch(
      "/mall/admin/alibabaGoods/productSearchImageQuery",
      {
        method: "POST",
        body: params,
      }
    );
  }
}

/**
 * 查询1688 图片
 * @param params
 * @returns {*}
 */
export function upload1688Img(params, $fetch, headers) {
  return useNuxtApp().$customFetch(
    "/mall/admin/alibabaGoods/productImageUpload",
    {
      method: "POST",
      body: params,
    }
  );
}




/**
 * 1688商品详情
 * @param params
 * @returns {*}
 */
export function get1688ProductDetail(params) {
  return useNuxtApp().$customFetch(
    "/mall/admin/alibabaGoods/productSearchQueryProductDetail?mall=1",
    {
      method: "POST",
      body: params,
      headers: {
        language: params.param.country,
        transferKeysConfig: JSON.stringify([
          ["data.sellerLoginId"],
          ["data.productShippingInfo.sendGoodsAddressText"],
        ]),
      },
    }
  );
}

/**
 * 加入购物车
 */
export function tbGlobalAddItemsToCart(params) {
  return useNuxtApp().$customFetch("/mall/admin/mallShoppingCart/add?mall=1", {
    method: "POST",
    body: params,
  });
}

/**
 * 查询仓库列表
 * @param params
 * @returns {*}
 */
export function getWarehouseList(params) {
  return useNuxtApp().$customFetch(
    `/platform/admin/dealer-shop-warehouse/query/warehouseList`,
    {
      method: "GET",
      params,
    }
  );
}


 
